<div class="row basic-component-padding no-top-padding">
    <div class="col-sm-12">
        <form [formGroup]="frmProductDetails" name="frmProductDetails" novalidate #createForm="ngForm" role="form">
            <div class="row no-padding" *ngIf = "partIndex || partIndex===0">
                <div class="col-sm-12 section-title" tabindex="0">
                    {{titleText}}
                </div>
            </div>
            <div class="row top-padding-medium">
                <div class="col-sm-12">
                  <div class="row">
                    <div class="col-sm-6">
                      <label aria-label="Proprietary Name" for="proprietaryName">Proprietary Name</label>
                    </div>
                    <div class="col-sm-6">
                      <label aria-label="Proprietary Name Suffix" for="proprietaryNameSuffix" class="float-start">Proprietary Name
                        Suffix</label>
                    </div>
                  </div>
                </div>

            </div>
            <div class="row">
                <div class="col-sm-12">
                  <div class="row">
                    <div class="col-sm-6">
                      <ejs-inplaceeditor id="proprietaryName"
                                         name="proprietaryName" #inplace_editor_ProprietaryName mode="Popup"
                                         type="Text" [value]="encodeHtml(dataProductDetail?.proprietaryName)"
                                         (actionBegin)="editorChanged($event)" (actionSuccess)="onActionSuccess($event)"
                                         [enableHtmlSanitizer]="false" [model]="proprietaryNameModel"
                                         formControlName="proprietaryName" class="mb-3">
                      </ejs-inplaceeditor>
                    </div>
                    <div class="form-group col-sm-6">
                      <ejs-inplaceeditor id="proprietaryNameSuffix"
                                         name="proprietaryNameSuffix" #inplace_editor_proprietaryNameSuffix mode="Popup"
                                         type="Text" [value]="encodeHtml(dataProductDetail?.proprietaryNameSuffix)"
                                         formControlName="proprietaryNameSuffix"
                                         class="mb-3"
                                         [model]="proprietaryNameSuffixModel" (actionBegin)="editorChanged($event)"  (actionSuccess)="onActionSuccess($event)"
                                         [enableHtmlSanitizer]="false"></ejs-inplaceeditor>
                    </div>
                  </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                  <div class="row">
                    <div class="col-sm-6">
                      <label class="float-start" aria-label="Established Generic Name" for="estabGenericNameObj">Established Generic Name</label>
                    </div>
                    <div class="col-sm-6">
                      <label class="float-start" aria-label="Dosage form" for="dosage">Dosage form</label>
                    </div>
                  </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                  <div class="row">
                    <div class="col-sm-6">
                      <ejs-inplaceeditor id="estabGenericNameObj"
                                         name="genericName" #inplace_editor_estabGenericNameObj mode="Popup"
                                         type="Text" [model]="genericNameModel" formControlName="genericName"
                                         class="mb-3"
                                         (actionBegin)="editorChanged($event)" (actionSuccess)="onActionSuccess($event)"
                                         [enableHtmlSanitizer]="false" [value]="encodeHtml(dataProductDetail?.estGenName)" >
                      </ejs-inplaceeditor>
                    </div>
                    <div class="col-sm-6">
                      <ejs-inplaceeditor id="dosage" #ipeDosage mode="Popup" type="DropDownList" class="mb=3"
                                         name="selectedDosage" [model]="dosageFormModel" [value]="selectedDosageId" textOption="Always"
                                         (actionBegin)="editorChanged($event)"></ejs-inplaceeditor>
                    </div>
                  </div>
                </div>
            </div>

        </form>
    </div>
</div>
